<!-- 暂时 -->
<template>
    <!-- <div class="hotsearch">
        <h3>热门搜索</h3>
        <ul>
            <li v-for="(item, index) in list" :key="index" @click="chooseHot(item)"><van-tag color="#151515" plain size="large">{{item}}</van-tag></li>
        </ul>
    </div> -->
</template>

<script>
import { Tag } from "vant";
export default {
  data() {
    return {
        list: this.$store.state.system.hotKey
    }
  },
  components: {
      [Tag .name]: Tag 
  },
  methods: {
    // chooseHot
    chooseHot (key) {
      this.$emit('accestKey', key)
    }
  }
};
</script>

<style scoped lang="less">
.hotsearch {
    width: 100%;
    height: auto;
    padding: 17px 20px 24px 20px;
    box-sizing: border-box;
    background: #fff;
    margin-bottom: 10px;
    &>h3 {
        font-size: 14px;
        font-weight:500;
        color:rgba(41,41,41,.8);
        margin-bottom: 15px;
    }
    &>ul {
        width: 100%;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        li {
            margin-right: 15px;
            margin-bottom: 15px;
            & /deep/ .van-tag {
                padding: .4em .6em;
                // letter-spacing: 3px;
                color: #151515 !important;
                font-size: 15px;
                font-weight: 500;
                padding-left: 16px;
                padding-right: 16px;
            }
        }
    }
}
</style>
